export default "__VITE_PUBLIC_ASSET__2e00d979__"